// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2iuIg","infoBtn":"quickbooks_infoBtn__lNUN1","formBox":"quickbooks_formBox__g7WqE","formFooter":"quickbooks_formFooter__2_Hz0"};